/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_Ai_AssistantInputs */



/**
* | output |
* | --- |
* | "Open or close the AI Assistant panel" |
*
* @param {Shortcut_Keys_Desc_Toggle_Ai_AssistantInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_ai_assistant = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_Ai_AssistantInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_Ai_AssistantInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir ou fermer le panneau de l'assistant IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnen oder schließen Sie das Bedienfeld „KI-Assistent“.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aprire o chiudere il pannello dell'Assistente IA")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыть или закрыть панель ИИ-помощника")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir o cerrar el panel del Asistente de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开或关闭人工智能助手面板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIアシスタントパネルを開くまたは閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई असिस्टेंट पैनल खोलें या बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra ou feche o painel do Assistente de IA.")
	return /** @type {LocalizedString} */ ("Open or close the AI Assistant panel")
});